import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Wine } from "lucide-react";

const LINKS = [
  { label: "The Society", id: "manifesto" },
  { label: "Gatherings", id: "events" },
  { label: "Ideas Board", id: "board" },
  { label: "Join", id: "join" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-wine-bg/70 border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
        >
          <Wine className="h-6 w-6 text-gold transition-transform duration-500 group-hover:-rotate-12" />
          <span className="font-display text-xl md:text-2xl leading-none tracking-tight text-cream">
            Macarthur <span className="italic text-terracotta">Wine</span> Society
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm text-smoke hover:text-cream transition-colors duration-300 uppercase tracking-[0.14em]"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-join-cta"
            onClick={() => go("join")}
            className="rounded-full bg-terracotta px-5 py-2.5 text-sm font-medium text-cream transition-all duration-300 hover:bg-gold hover:text-wine-bg hover:-translate-y-0.5"
          >
            Join the Society
          </button>
        </div>
      </div>
    </header>
  );
}
